import { AType, summon } from "@silversea-ssc/functional-support"
import { Amount } from "../amount"
import { DateOnly } from "@ssc-booking/functional-support"

const _DepositType = summon((F) => F.keysOf({ deposit: null, fullPayment: null }))
export type DepositType = AType<typeof _DepositType>
export const DepositType = /* @__PURE__ */ Object.assign(_DepositType, {})

export const SuitePayment = summon((F) =>
    F.interface(
        {
            type: DepositType(F),
            percentage: F.number(),
            amount: Amount(F),
            balanceAmount: Amount(F),
            totalAmount: Amount(F),
            finalDueDate: DateOnly(F),
        },
        "SuitePayment",
    ),
)
export type SuitePayment = AType<typeof SuitePayment>
